export default __webpack_public_path__ + "static/media/tableImagejs.61e15eaa.bin";